import React, { useEffect, useState } from 'react';
import { Banner } from '@intigral/shared';
import h from '../../helpers/common';
import user from '../../helpers/user';
export const BSAddonsBanner = (props) => {
    const content = props.content?.map((item) => {
        return {
            ...item,
            banner_content: `<img src="${item?.banner_content}" style="object-fit: cover" />`,
        };
    });

    const userLanguage = h.getLang();
    const allowedOperators = props?.meta?.allowed_operators || [];
    const userInfo = user.getUserInfo();
    const operator = userInfo?.operator;
    const [userOperator, setUserOperator] = useState(null);

    useEffect(() => {
        setUserOperator(operator);
    }, [operator]);

    const contentToShow = [];
    content.map((el, ind) => {
        if (el.lang === userLanguage) {
            contentToShow.push({
                key: `BS-${ind}`,
                content: `<a href="${el.link}" class="discount-link">${el.banner_content}</a>`,
            });
        }
    });

    try {
        return (
            contentToShow && (
                // TODO will do the operators work later
                // (allowedOperators.length === 0 || allowedOperators.includes(userOperator)) && (
                <Banner banners={contentToShow} withCubeAnimation />
            )
            // )
        );
    } catch (e) {
        return null;
    }
};
